import React, { useState } from "react";
import { Table } from "antd";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { refreshicon } from "../imagepath";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { getMessageLogList } from "../../connections/getMessageLogList";

const MessageLogList = () => {
  const { user: { user } } = useSelector((store) => store);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["getMessageLogList", page, pageSize],
    queryFn: () => getMessageLogList(user?.token, page, pageSize),
    enabled: !!user?.token,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Message Type",
      dataIndex: "message_type",
      key: "message_type",
      render: (text) => text || "-",
    },
    {
      title: "Sender Type",
      dataIndex: "sender_type",
      key: "sender_type",
      render: (text) => text || "-",
    },
    {
      title: "Sender Id",
      dataIndex: "sender_id",
      key: "sender_id",
      render: (text) => text ?? "-",
    },
    {
      title: "Receiver Type",
      dataIndex: "receiver_type",
      key: "receiver_type",
      render: (text) => text || "-",
    },
    {
      title: "Receiver Id",
      dataIndex: "receiver_id",
      key: "receiver_id",
      render: (text) => text ?? "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <span
          className={
            text === "success"
              ? "custom-badge status-green"
              : "custom-badge status-pink"
          }
        >
          {text || "-"}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => text || "-",
    },
    {
      title: "",
      key: "actions",
      render: (_, record) => (
        <Link
          to={`/admin/message-logs/${record.id}`}
          className="btn btn-sm btn-primary"
        >
          <FeatherIcon icon="eye" size={14} className="me-1" />
          View
        </Link>
      ),
    },
  ];

  return (
    <>
      <Header />
      <Sidebar activeClassName="message-logs" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Message Logs</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <FeatherIcon icon="chevron-right" />
                  </li>
                  <li className="breadcrumb-item active">Message Logs List</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Message Logs</h3>
                          <div className="doctor-search-blk">
                            <div className="add-group">
                              <Link
                                onClick={refetch}
                                className="btn btn-primary doctor-refresh ms-2"
                              >
                                <img src={refreshicon} alt="#" />
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive doctor-list">
                    <Table
                      loading={isLoading}
                      pagination={{
                        current: page,
                        pageSize: pageSize,
                        total: data?.meta?.total_count,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        onChange: (newPage, newPageSize) => {
                          setPage(newPage);
                          setPageSize(newPageSize);
                        },
                      }}
                      columns={columns}
                      dataSource={data?.payload?.message_logs}
                      rowKey={(record) => record.id}
                      scroll={{ x: "max-content" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageLogList;
